
<template>
	<div class="header" :style="tmpTheme">
		<div class="headers">
				<div class="topmenu_list" :style="tmpTheme">
						<dl style="border: none;" v-if="!isLogin">
								<!-- <dd><a href="">免费注册</a></dd> -->
								<!-- <dd class="spacer"></dd> -->
								<dd><router-link to="/login">登录</router-link></dd>
								<dd class="spacer"></dd>
								<dd><a href="/order">会员中心</a></dd>
								
								<dd class="spacer"></dd>
								<dd class="remember_st">
										<a class="guanzhu_st" href="">关注{{ base.webFullName }}<i></i></a>
										<ul class="remember_content">
												<li><a @click="addFavorite()">收藏网址</a></li>
												<li><a @click="setHome(this)">设为首页</a></li>
												<li v-if="isShowQr"><a>关注{{ base.webFullName }}</a></li>
												<li v-if="isShowQr"><img :src="qrcode"></li>
										</ul>
								</dd>
								<dd class="spacer" v-if="hotPhoneIsShow"></dd>
								<dd style="border-right:0;padding-right: 0;" v-if="hotPhoneIsShow"><a>热线：{{hotPhone}}</a></dd>
						</dl>
						<dl style="border: none;" v-else>
								<!-- <dd><a href="">免费注册</a></dd> -->
								<!-- <dd class="spacer"></dd> -->
								
								<dd><a href="/order">会员中心</a></dd>
								<dd class="spacer"></dd>
								<dd><a style="cursor: pointer;" @click="tui()">退出</a></dd>
								<dd class="spacer"></dd>
								<dd class="remember_st">
										<a class="guanzhu_st" href="">关注{{ base.webFullName }}<i></i></a>
										<ul class="remember_content">
												<li><a @click="addFavorite()">收藏网址</a></li>
												<li><a @click="setHome(this)">设为首页</a></li>
												<li v-if="isShowQr"><a>关注{{ base.webFullName }}</a></li>
												<li v-if="isShowQr"><img :src="qrcode"></li>
										</ul>
								</dd>
								<dd class="spacer" v-if="hotPhoneIsShow"></dd>
								<dd style="border-right:0;padding-right: 0;" v-if="hotPhoneIsShow"><a>热线：{{hotPhone}}</a></dd>
						</dl>
				</div>
		</div>

		<div class="headerBox" :style="tmpTheme">
			<div class="headerWrap">
				<a class="logoArea" href="/">
						<!-- <img src="../assets/img/logo.png"> -->
						<img :src="webLogo">
				</a>
				<div class="menurightBox">
						<div class="rt_wrap">
								<div class="navArea">
										<div class="enterArea">
												<input type="text" placeholder="请输入商品信息，关键字用空格隔开 例: 912 12.9 5*20" 
												:style="{'border-color': $store.state.theme.bgColor}"
												id="keywords" name="keywords" v-model="keywords" @keyup.enter="search">
												<a style="cursor:pointer;" :style="{'background': $store.state.theme.bgColor}" @click="search()">
														搜索
												</a>
										</div>
										<ul>
												<li v-for="(item,index) in searchData" :key="index"><el-link type="info" @click="toSearch(item.searchValue)">{{item.searchValue}}</el-link></li>
										</ul>
								</div>
								<div class="btn_quick" @click="goQuick" v-if="isLogin">
									<i class="iconfont">&#xe785;</i>
									<span>快速下单</span>
								</div>
								<!-- <div class="shopcarArea" @click="goCart" :style="{'border-color': $store.state.theme.bgColor}"> -->
								<a class="shopcarArea" @click="goCart" :style="{'border-color': $store.state.theme.bgColor}" v-if="isLogin">
										
									<!-- <img src="../assets/img/cart.png"> -->
									<i class="iconfont cart_icon">&#xe73d;</i>
									<CartCount :isHeader="true" :getLogin="isLogin" ref="CartChild"></CartCount>
									<i class="iconfont enter_icon">&#xe8d4;</i>
									 
								</a>
								<div class="noLogin_btn" v-if="!isLogin">
									<div class="btn_nologin btn_lo"><router-link to="/login">登录</router-link></div>
									<div class="btn_nologin btn_re"><router-link to="/register">注册</router-link></div>
								</div>

						</div>

				</div>
			</div>
		</div>

		<div id="nav" :style="{backgroundColor:navigaColor}">
				<!-- <div class="nav_box" :class="{newStyle:homeNavStyle==2,newH:homeChartStyle==1,newHE:homeChartStyle==2}"> -->
				<div class="nav_box" :class="{newStyle:homeNavStyle==2}">
						<ul>
						<li class="all">
								<i class="iconfont">&#xe6b8;</i>
								<a>所有商品分类</a>
								<!--一级导航-->
								<div class="nav_two" :style="{height:navTwoHeight+'px',backgroundColor:classColor}">
										<span class="nav_two_span" v-for="(item, index) in classified" :key="index">
												<div class="name" @mouseover="navTwo(index)" :style="{height:navTwoHeight/classified.length+'px',lineHeight:navTwoHeight/classified.length+'px'}">
														<a class="lm_title">{{ item.name }}</a>
														<i class="iconfont">&#xe8d4;</i>
												</div>
												<!--3级导航-->
												<div class="nav_three_box" :style="{height:navTwoHeight+'px'}">
														<div>
																<a class="navsubtype" v-for="(item2, index) in item.children" :key="index" @click="getCur(index, item)" :class="{current:curIndex == index}">{{item2.name}}</a>
																<div style="clear:both;"></div>
														</div>
														
																<div class="navtab" v-for="(item3, index) in item.children" :key="index" :class="{active:curIndex == index}">
																		<div class="hot_wrap" v-if="item3.hostData&&item3.hostData.length">
																			<div class="hot_title"><img src="../assets/img/HOT.png"/></div>
																			<div class="hot_list">
																				<div class="nt_row_right">
																					<div class="nt_row_right_li" v-for="(item5, index) in item3.hostData" :key="index">
																						<a class="text_wrap" @click="hotsiji(item,item3,item5)" v-if="homeNavStyle==1">
																							<div class="text">{{item5.name}}</div>
																							<div class="nt_show">
																								<img :src="item5.img_Url==''||item5.img_Url==null?base.imgWebUrl+base.sp_Type_DefPic:base.imgWebUrl+item5.img_Url">
																								<div :title="item5.typeDescribe" class="title_text">{{ item5.typeDescribe }}</div>
																								
																								<div class="nt_show_san"></div>
																								<div class="nt_show_san2"></div>
																							</div>
																						</a>
																						<a class="text_wrap" @click="hotsiji(item,item3,item5)" v-if="homeNavStyle==2">
																							<div class="nt_show">
																								<img v-lazy="item5.img_Url==''||item5.img_Url==null?base.imgWebUrl+base.sp_Type_DefPic:base.imgWebUrl+item5.img_Url">
																								
																							</div>
																							<div class="text">{{item5.name}}</div>
																							<div :title="item5.typeDescribe" class="title_text">{{ item5.typeDescribe }}</div>
																								
																						</a>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div class="nav_three_row" v-for="(item4, index) in item3.children" :key="index">
																				<div class="nt_row_left">
																						<a @click="sanji(item,item3,item4)">{{item4.name}}
																						</a>
																				</div>
																				<div class="nt_row_right">
																						
																						<div class="nt_row_right_li" v-for="(item5, index) in item4.children" :key="index">
																								<a @click="siji(item,item3,item4,item5)" class="text_wrap" :class="{hot:item5.isHot}" v-if="homeNavStyle==1">
																										<div class="text">{{item5.name}}</div>
																										<div class="nt_show nt_show_1">
																										
																												<img v-lazy="item5.img_Url==''||item5.img_Url==null?base.imgWebUrl+base.sp_Type_DefPic:base.imgWebUrl+item5.img_Url">
																												<div :title="item5.typeDescribe" class="title_text">{{ item5.typeDescribe }}</div>
																												
																												<div class="nt_show_san"></div>
																												<div class="nt_show_san2"></div>
																										</div>
																								</a>
																								<a @click="siji(item,item3,item4,item5)" class="text_wrap" :class="{hot:item5.isHot}" v-if="homeNavStyle==2">
																										<div class="nt_show">
																												<img v-lazy="item5.img_Url==''||item5.img_Url==null?base.imgWebUrl+base.sp_Type_DefPic:base.imgWebUrl+item5.img_Url">
																										</div>
																										<div class="text">{{item5.name}}</div>
																										<div :title="item5.typeDescribe" class="title_text">{{ item5.typeDescribe }}</div>
																								</a>
																						</div>
																				</div>
																		</div>
																</div>
												</div>
										</span>
								</div>
						</li>
						<li class="headnav" v-for="(item, index) in naviga" :key="index" :class="{actives:navindex === index}" @click="qie(index,item)" >
							<div class="headnav_box" v-if="openCustomized&&item.code=='nonStandard'&&item.isShow">
								<div v-if="item.type==1">
									<i class="iconfont" v-html="item.icon"></i>
									<span :style="{fontSize:item.fontSize+'px',color:item.fontcolor}">{{item.name}}</span>
								</div>
								<div class="focusImg" v-else>
									<img class="img" :src="item.dialogImageUrl">
								</div>
							</div>
							<div class="headnav_box" v-if="item.code!='nonStandard'&&item.isShow">
								<i class="iconfont" v-if="index!=0" v-html="item.icon"></i>
								<span :style="{fontSize:item.fontSize+'px',color:item.fontcolor}">{{item.name}}</span>
							</div>
						</li>
						</ul>
				</div>
		</div>

		<!-- 投诉 -->
		<el-dialog title="投诉反馈" width="550px" :visible.sync="complaintVisible" class="complaint">
				<div class="content_complaint">
					<div class="btn_my" @click="goComplaint">我的投诉记录</div>
					<div class="form_box">
						<div class="form_item">
							<div class="lable"><em>*</em>问题类型：</div>
							<div class="inp">
									<el-select v-model="form.type" placeholder="请选择" size="small" class="select">
										<el-option
										v-for="item in form.optiontype"
										:key="item.value"
										:label="item.label"
										:value="item.value">
										</el-option>
									</el-select>
							</div>
						</div>
						<div class="form_item">
							<div class="lable">订单号：</div>
							<div class="inp">
									<input class="input" type="text" v-model="form.orderNo">
							</div>
						</div>
						<div class="form_item">
							<div class="lable"><em>*</em>问题描述：</div>
							<div class="inp">
									<textarea class="textarea" type="text" v-model="form.describe"></textarea>
							</div>
						</div>
						<div class="form_item">
							<div class="lable"><em>*</em>我的诉求：</div>
							<div class="inp">
									<textarea class="textarea" type="text" v-model="form.appeal"></textarea>
							</div>
						</div>
						<div class="form_item">
							<div class="lable"><em>*</em>上传图片：</div>
							<div class="inp">
								<!-- :on-preview="handlePictureCardPreview" -->
								<el-upload
										:action="GlobalConfig.BASE_URL+'api/customized/UploadForApi'"
										:headers="upload.headers"
										list-type="picture-card"
										:limit="5"
										:on-exceed="handleExceed"
										
										:on-remove="handleRemove"
										:on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<i class="el-icon-plus"></i>
									</el-upload>
									<el-dialog :visible.sync="dialogVisible">
										<img width="100%" :src="dialogImageUrl" alt="">
									</el-dialog>
									<div class="tip">(图片大小＜10M,最多上传5张，支持JPG,JPEG,PNG格式)</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
						<el-button class="cancel" @click="complaintVisible = false">关闭</el-button>
						<el-button class="sure" @click="addComplaint">确定</el-button>
				</div>
		</el-dialog>
	</div>
</template>

<script>
import CartCount from '../components/homejs/CartCount';
export default {
	name: 'Header',
	props:{
	},
		components:{
				CartCount
		},
	data() {
		return {
			isLogin:true,
			qrcode:'',
			hotPhone:'',
			hotPhoneIsShow:false,
			curIndex:0,
			classified:'',
			navigaColor:'',
			classColor:'',
			naviga:[
				// {
				// 		icon:'',
				// 		name:'首页'
				// },
				// {
				// 		icon:'&#xe626;',
				// 		name:'分类购买'
				// },
				// {
				// 		icon:'&#xe627;',
				// 		name:'我的自定义商品'
				// },
				// {
				// 		icon:'&#xe624;',
				// 		name:'非标定制'
				// },
				// {
				// 		icon:'&#xe631;',
				// 		name:'投诉反馈'
				// }
			],
			navindex:0,
			major:[],
			searchData: [],
			base:'',
			keywords:'',
			webLogo:'',
			cartnum:0,
			//所有商品分类高度计算
			navTwoHeight:0,//父元素初始高度
			hei:'',//子元素元素高度
			lHit:'',//子元素元素行高
			homeNavStyle:1, //2新样式 1老样式 导航和banner样式切换
			searchDefaultStyle:'',
			openCustomized: 0,//是否开启非标定制品  1是 0否

		customizedStyle:1,//非标定制样式 1正常样式  2突显样式
		customizedImgSrc:'',//主导航非标定制

		complaintVisible: false,//
		form:{
			type:'',
			optiontype:[
				// {
				// 	value:1,
				// 	label:'类型一'
				// },
				// {
				// 	value:2,
				// 	label:'类型二'
				// }
			],
			orderNo:'',
			describe:'',
			appeal:'',
		},
		
		GlobalConfig:'',
		upload: {
			// 是否更新已经存在的数据
			updateSupport: true,
			// 设置上传的请求头部
			headers: { 
				Authorization: "Bearer " + localStorage.getItem('token'),
				sign: this.$md5('E813A75BB45D4E158EA0801B1BDB2D61'+this.$moment(new Date()).format("YYYYMMDDHHmm"))
			},

			},
			dialogImageUrlList:[],
			dialogImageUrl:'',//上传图片
			dialogVisible: false,
			homeChartStyle:'',
			isShowQr:'',
		}
	},
		computed:{
				tmpTheme(){
						return {
								'--bgColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.bgColor:'#fff',
								'--fontColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.fontColor:'#fff',
								'--navbgColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.nav_BgColor:'#fff',
								'--navfontColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.nav_FontColor:'#fff',
						};
				}
		},
		watch:{$route(to,from){
				if(this.$route.query.keyword){
						this.keywords=this.$route.query.keyword
				} else {
						this.keywords = ''
				}
		}},
	created(){
		//配置信息
		const _this = this;
		if(localStorage.getItem('GlobalConfig')){
			this.GlobalConfig = JSON.parse(localStorage.getItem('GlobalConfig'))
		}
		
		_this.loadconfig(true,function(data){
				_this.base=_this.$store.state.sysConfig.baseConfig
				_this.openCustomized=_this.$store.state.sysConfig.funcConfig.openCustomized; //是否开启非标定制品  1是 0否
				// _this.webLogo=_this.base.imgWebUrl+_this.base.webLogo
				_this.searchDefaultStyle=_this.$store.state.sysConfig.funcConfig.searchDefaultStyle; //1经销商模式   2终端模式    新样式为终端客户模式也就是2
				// _this.searchDefaultStyle=JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle; //1经销商模式   2终端模式    新样式为终端客户模式也就是2
				// _this.homeNavStyle=_this.$store.state.sysConfig.funcConfig.homeNavStyle; //2新样式 1老样式

			// _this.homeChartStyle=_this.$store.state.sysConfig.funcConfig.homeChartStyle; //轮播图 1高度420样式 2高度620样式
			// _this.navTwoHeight = _this.homeChartStyle==2?620:423;
			_this.customizedStyle=_this.$store.state.sysConfig.funcConfig.customizedStyle; //非标定制样式 1正常样式  2突显样式
			// _this.customizedImgSrc=_this.base.imgWebUrl+_this.$store.state.sysConfig.funcConfig.customizedImgSrc; 
			
			_this.$api.classify().then(res=>{
				_this.classified=res.data.data;
					_this.hei = (_this.navTwoHeight/_this.classified.length);
					_this.lHei = (_this.navTwoHeight/_this.classified.length);
			})
	})
	
	
	if(this.$route.query.keyword){
			this.keywords = this.$route.query.keyword
	}

	this.getCurrentDateTime();
	if(this.$route.path=='/category'||this.$route.path=='/catlist'){
			this.navindex=1
	}else if(this.$route.path=='/home'){
			this.navindex=0
	}else if(this.$route.path=='/quickOrder'){
			this.navindex=2
	} else if(this.$route.path=='/customNonStandard'){
			this.navindex=3
	} else{
			this.navindex=-1
	}
	if(localStorage.getItem('token')!=null){
			this.isLogin=true;
	}else{
			this.isLogin=false
	}

	this.$api.getSearchRecordList().then(res=>{
			this.searchData=res.data.data;
	})

	this.getCartNum();

		this.getConfigData();

		
		
	},
	mounted(){
		// window.addEventListener("scroll", this.handleScroll, true);
		//window.addEventListener('keydown', this.handkeyCode, true)//开启监听键盘按下事件
	},
	methods:{
		//获取配置
		getConfigData(){
			const _this = this;
			let params={
				templateType:'homeTemplatePc', //模板类型：homeTemplatePc电脑端，homeTemplateMob手机端
			};
			this.$api.GetHomeTemplate(params).then(res=>{
				
				if(res.data.status){
					let fetch = res.data.data;
					console.log(fetch)
					if(fetch){
						//关注二维码
						_this.qrcode = fetch.topheaderData.dialogImageUrl;
						_this.hotPhone = fetch.topheaderData.hotPhone;
						_this.hotPhoneIsShow = fetch.topheaderData.hotPhoneIsShow;
						_this.isShowQr = fetch.topheaderData.isShowQr;
						//logo
						_this.webLogo = fetch.headerData.dialogImageUrl;
						let navigaList = fetch.headerData.naviga;
						if(navigaList.length){
							_this.naviga = navigaList;
						}
						_this.navigaColor = fetch.headerData.navigaColor;
						_this.classColor = fetch.headerData.classColor;
						//首页分类样式
						_this.homeNavStyle = fetch.bannerPartData.homeClassStyle;
						_this.navTwoHeight = fetch.bannerPartData.isShowBannerAvatar=='2'?fetch.bannerPartData.avatarHeightType:fetch.bannerPartData.heightType;
					} 
				} else {
					this.$message.error(res.message)
				}
			});
		},
		goComplaint(){
			this.complaintVisible = false;
			this.$router.push({path:'/Complaint'})
		},
		//=================投诉反馈======================================
		//投诉反馈 获取下拉框的值
		getComplaintEnum(){
			this.$api.GetComplaintEnum().then(res=>{
				if(res.data.status){
					let fetch = res.data.data;
					if(fetch.complaintCategoryList.length){
						this.form.optiontype = [];
						fetch.complaintCategoryList.forEach(n=>{
							this.form.optiontype.push({
								value: n.id,
								label: n.name,
							})
						})
					}
					
				}else{
					this.$message.error(res.data.message?res.data.message:'获取投诉问题类型失败');
				}
			})
		},
		//上传图片
		handleRemove(file, fileList) {
			this.dialogImageUrlList = fileList;
			console.log(this.dialogImageUrlList);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		handleAvatarSuccess(obj,res,file) {
			this.dialogImageUrlList = file;
			console.log(this.dialogImageUrlList);
		},
		beforeAvatarUpload(file){
			const isJPG = file.type === 'image/jpg'||file.type === 'image/png'||file.type === 'image/jpeg';
			const isLt2M = file.size / 1024 / 1024 < 10;
			console.log(isLt2M)

		if (!isJPG) {
		this.$message.error('上传图片只能是 JPG/png 格式!');
		}
		if (!isLt2M) {
		this.$message.error('上传图片大小不能超过 10MB!');
		}
		return isJPG && isLt2M;
	},
	// handleExceed(files, fileList) {
	handleExceed(files, fileList) {
		this.$message.warning('最多可上传5张图片');
	},
	addComplaint(){
		let params = {
			"orderNo": this.form.orderNo,
			"categoryId": this.form.type,
			"imgs": this.form.orderNo,
			"remark": this.form.describe,
			"myRemark": this.form.appeal
		}
		let imglist = []
		if(!this.form.type){
			this.$message.error('请选择问题类型！');
			return false;
		}
		if(!this.form.describe){
			this.$message.error('请填写问题描述！');
			return false;
		}
		if(!this.form.appeal){
			this.$message.error('请填写我的诉求！');
			return false;
		}
		if(!this.dialogImageUrlList.length){
			this.$message.error('请上传图片！');
			return false;
		} else {
			imglist = [];
			this.dialogImageUrlList.forEach(n=>{
				imglist.push(this.base.imgWebUrl+n.response.data)
			})
		}
		params.imgs = imglist.toString();
		// console.log(params)
		// return false
		this.$api.AddComplaint(params).then(res=>{
			if(res.data.status){
				this.complaintVisible = false;
				//刷新投诉反馈列表
				if(this.$route.path=='/Complaint'){
					this.$emit('uploadAgin',true)
				}
				this.$message.success(res.data.message?res.data.message:'投诉反馈提交成功');
				this.$router.push({path:'/Complaint'})
				
			}else{
				this.$message.error(res.data.message?res.data.message:'获取投诉问题类型失败');
			}
		})
	},
	//=================投诉反馈======================================

	addFavorite() {
			var title = this.base.webFullName;
			var url = location.href;
			try {
					window.external.addFavorite(url, title);
			}
			catch (e) {
					try {
							window.sidebar.addPanel(title, url, "");
					}
					catch (e) {
							alert("抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加");
					}
			}
	},
	
	//设为首页
	setHome(obj) {
			var url = location.href;
			try {
					obj.style.behavior = 'url(#default#homepage)';
					obj.setHomePage(url);
			} catch (e) {
					if (window.netscape) {
							try {
									netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
							} catch (e) {
									alert("抱歉，此操作被浏览器拒绝！请在浏览器地址栏输入“about:config”并回车然后将[signed.applets.codebase_principal_support]设置为'true'");
							}
					} else {
							alert("您的浏览器不支持该功能，请手动将【" + url + "】设置为首页");
					}
			}
	},
	getCartNum(){
			this.$api.getCartNum({}).then(res=>{
					localStorage.setItem("cartNum", res.data.data || 0);
			})
	},
	syncCartNum(cartCount){
			this.$refs.CartChild.syncCartNum(cartCount);
	},
	getCurrentDateTime () {
			this.$api.getCurrentDateTime().then(res=>{
					if(res.data.code == 401){
							this.isLogin=false;
							this.$emit("getLogin", this.isLogin);
							localStorage.removeItem('username');
							localStorage.removeItem('token');
							localStorage.removeItem('buyerInfo');
							localStorage.removeItem('cartNum');
					}
			})
	},
	tui(){
			// localStorage.removeItem('username')
			// localStorage.removeItem('token');
			// localStorage.removeItem('buyerInfo');
			localStorage.clear();
			this.$router.push('/login')
	},
	goCart(){
			this.$router.push({path:'/cart'})
	},
	qie(index,item){
			if(item.code=='home'){
					this.navindex=index
					this.$router.push('/')
			}else if(item.code=='classify'){
					this.navindex=index
					this.$router.push('/category')
			} else if(item.code=='customCode'){
					this.navindex=index
					this.$router.push({path:'/quickOrder',query:{tab:3}})
			} else if(item.code=='nonStandard'){
					this.navindex=index
					this.$router.push({path:'/customNonStandard'})
			} else if(item.code=='complaint'){
				if(!this.isLogin){
					// this.$message.error('请先登录')
					this.$router.push({path:'/login',query: { redirect: location.href }})
				} else {
					this.complaintVisible = true;
					this.getComplaintEnum();
				}
					
			} else if(item.code=='order'){
				if(!this.isLogin){
					this.$router.push({path:'/login',query: { redirect: location.href }})
				} else {
					this.$router.push({path:'/order'})
				}
					
			}
	},
	
	goQuick(){
			this.$router.push({path:'/quickOrder',query:{tab:3}})
	},
	handleScroll() {
		let scrolltop = this.$refs.nav_three_box.scrollTop;
		console.log(this.$refs.nav_three_box)
		console.log(scrolltop)
	},
	navTwo(index){
		this.curIndex = 0;
		document.getElementsByClassName('nav_three_box')[index].scrollTop = 0;
	},
	getCur(a, b) {
			this.curIndex = a;
	},
	xiaolei(item,item1,items){
			this.$router.push({path:'/category',query:{bigid:item.id,cz:item1.name,smalls:items.id}})
	},
	siji(item,item3,item4,item5){
		let searchDefaultStyle = JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle;
		let path = ''
		if(searchDefaultStyle==1){
			path = '/catlist'
		}else if(searchDefaultStyle==2){
			path = '/terminalMode'
		}
			let text= this.$router.resolve({
					path: path,
					query:{da:item.id,cai:item3.czId?item3.czId:'',xiao:item4.id,prod:item3.id,bz:item5.bzId,time: Date.parse(new Date()),img:item5.img_Url,bzName:item5.name,bzRemark:item5.typeDescribe}
			});
					
			// 打开一个新的页面     
			window.open(text.href, '_blank')
	},
	sanji(item,item3,item4){
		let searchDefaultStyle = JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle;
		let path = ''
		let text = ''
		if(searchDefaultStyle==1){
			path = '/catlist'
			text= this.$router.resolve({
				path: path,
				query:{da:item.id,cai:item3.czId?item3.czId:'',xiao:item4.id,prod:item3.id,bz:'',time: Date.parse(new Date()),img:item4.img_Url,bzName:item4.name,bzRemark:item4.typeDescribe,level:3}
				});
		}else if(searchDefaultStyle==2){
			//点击二级默认选择二级下第一个标准
			path = '/terminalMode'
			text= this.$router.resolve({
				path: path,
				query:{da:item.id,cai:item3.czId?item3.czId:'',xiao:item4.id,prod:item3.id,bz:item4.children[0].bzId,time: Date.parse(new Date()),img:item4.children[0].img_Url,bzName:item4.children[0].name,bzRemark:item4.children[0].typeDescribe,level:3}
			});
		}
		
		// 打开一个新的页面     
		window.open(text.href, '_blank')
},
hotsiji(item,item3,item5){
	let searchDefaultStyle = JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle;
	let path = ''
	if(searchDefaultStyle==1){
		path = '/catlist'
	}else if(searchDefaultStyle==2){
		path = '/terminalMode'
	}
	let text= this.$router.resolve({
			path: path,
			query:{da:item.id,cai:item3.czId?item3.czId:'',xiao:item5.parentId,prod:item3.id,bz:item5.bzId,time: Date.parse(new Date()),img:item5.img_Url,bzName:item5.name,bzRemark:item5.typeDescribe}
	});
				
	// 打开一个新的页面     
	window.open(text.href, '_blank')
},
	handkeyCode(e){
		let searchDefaultStyle = JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle
		if(searchDefaultStyle==2){
			this.$router.push({path:'/categorySearch',query:{keyword:this.keywords,time: Date.parse(new Date())}})
		} else if(searchDefaultStyle==1){
			this.$router.push({path:'/catlist',query:{keyword:this.keywords,time: Date.parse(new Date())}})
		}
	},
	search(){
		let searchDefaultStyle = JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle
		if(searchDefaultStyle==2){
			this.$router.push({path:'/categorySearch',query:{keyword:this.keywords,time: Date.parse(new Date())}})
		} else if(searchDefaultStyle==1){
			if(this.keywords){
				this.$router.push({path:'/catlist',query:{keyword:this.keywords,time: Date.parse(new Date())}})
			} else {
				this.$message.error('请输入搜索信息！')
			}
		}
	},
	toSearch(keyword){
		let searchDefaultStyle = JSON.parse(localStorage.getItem('sysConfig')).funcConfig.searchDefaultStyle
		if(searchDefaultStyle==2){
			this.$router.push({path:'/categorySearch',query:{keyword:keyword,time: Date.parse(new Date())}})
		} else if(searchDefaultStyle==1){
			this.$router.push({path:'/catlist',query:{keyword:keyword,time: Date.parse(new Date())}})
		}
	}
}
}
</script>
<style>
.content_complaint .selected {
background-color: unset !important;
}
</style>
<style scoped lang="scss">
@import url('../assets/style/index.css');
.noLogin_btn {
display: flex;
align-items: center;
.btn_nologin {
	border: 1px solid var(--bgColor,red);
	color: var(--bgColor,red);
	border-radius: 5px;
	margin: 0 10px;
	cursor: pointer;
	a {
		padding: 7px 33px;
		display: inline-block;
		color: var(--bgColor,red);
	}
}

.btn_lo {
	border: 1px solid var(--bgColor,red);
	color: var(--bgColor,red);
}
}
.headerBox {
width: 100% !important;
display: unset;
}
.headerWrap {
width: 1200px;
margin: 0 auto;
height: 100px;
width: 1200px;
margin-bottom: 10px;
display: flex;
}

.rt_wrap {
margin-top: 20px;
align-items: baseline !important;
}
.headerBox.headerBoxFiexd {
position: fixed;
top: 0;
left: 0;
right: 0;
background-color: #000000de;
z-index: 1000;
height: 75px;
.btn_lo {
	border-color: #fff;
	a {
		color: #fff;
	}
}
.btn_nologin {
	.btn_lo {
		color: #fff;
	}
}

.logoArea img {
	height: 45px;
	margin: 13px 0;
}
.rt_wrap {
	margin-top: 20px;
	align-items: baseline !important;
}
.navArea ul {
	display: none;
}
.navArea input {
	border-color: #fff !important;
}
}
.btn_nologin:hover {
background-color: var(--bgColor,red)!important;
color: #fff!important;
border: 1px solid var(--bgColor,red)!important;
}
.btn_nologin:hover a{
color: #fff!important;
}
.topmenu_list dl dd a:hover {
		color: var(--bgColor,#e60012);
}
.remember_st .guanzhu_st:hover {
		color: var(--bgColor,#e60012);
}
.current{
		border: 1px solid transparent !important;
		background: #e50015;
		color: #fff;
		border-radius: 4px;
}
#nav {
		border-bottom:1px solid var(--bgColor,red);
		background: var(--navbgColor,#fff);
}
#nav .nav_box .nav_two {
		position: absolute;
		display: none;
		z-index: 999;
		left: 0;
		top: 36px;
		// background: rgba(0,0,0,.7);
}
#nav .nav_box li.all {
		background: var(--bgColor, red);
}
#nav .nav_box li.all:hover .nav_two{
		display: block;
}
#nav .nav_box li.headnav {
		// margin-left: 79px;
		padding: 0;
		font-weight: bold;
}
#nav .nav_box li.headnav .headnav_box {
		margin-left: 65px;
}
#nav .nav_box li.headnav i {
		margin-right: 5px;
		color: var(--bgColor, #999);
		font-size: 18px;
	display: inline-block;
	// vertical-align: middle;
	// margin-top: 2px;
}

#nav .nav_box li.headnav span {
display: inline-block;
// vertical-align: middle;
color: var(--navfontColor,#333);
}
#nav .nav_box .nav_two .nav_two_span .name {
	position: relative;
	// height: 42px;
	// line-height: 42px;
}
#nav .nav_box .all .nav_two .nav_two_span div a:hover{
	color: var(--bgColor,#fff);
}
.navtab:nth-child(3){
	display: none;
}
.navArea ul {
	padding-top: 8px;
	min-height: 28px;
}
.navArea ul li{
	display: inline-block;
	margin-right: 16px;
	border-radius: 2px;
	font-size: 12px;
	color: #888;
	padding: 2px;
	border-radius: 2px;
}
#nav .nav_box li.actives{
	color: var(--bgColor,#e60012);
}
#nav .nav_box a.current{
	background: var(--bgColor,#e60012);
	color: var(--fontColor,#fff)!important;
}
#nav .nav_box .nav_two .nav_three_box span:hover a{
	background: var(--bgColor,#e60012);
	color: var(--fontColor,#fff);
}
#nav .nav_box li span.nav_two_span:hover a.lm_title{
	color: var(--bgColor,#e60012);
}
.btn_quick {
	height: 36px;
	line-height: 36px;
	border-radius: 3px;
	padding: 0 20px;
	margin-right: 18px;
	color: #fff;
	background-color: var(--bgColor,#e60012);
	cursor: pointer;
}
.shopcarArea {
	display: flex;
	align-items: center;
	margin: 0;
	width: 120px;
	height: 35px;
}
.shopcarArea .cart_icon {
	font-size: 20px;
	color: var(--bgColor,#e60012);
}
.shopcarArea .enter_icon {
	color: var(--bgColor,#e60012);
}
#nav .nav_box .nav_two .nav_two_span .nav_three_box .navtab {
	display: none;
}
#nav .nav_box .nav_two .nav_two_span .nav_three_box .navtab.active {
	display: block;
}
// 热销
.nt_row_right {
.nt_row_right_li {
	.text_wrap{}
	.text_wrap.hot{
		color: var(--bgColor,red) !important;
		font-weight: bold;
	}
}
}
.hot_wrap {
.hot_title {
	img {
		height: 16px;
	}
}
.hot_list {
	.nt_row_right {
		.nt_row_right_li {
			line-height: unset;
			margin: 10px 10px 10px 0;
			.text_wrap {
				display: block;
				.text {
					font-size: 13px;
					color: var(--bgColor,red) !important;
				}
				.nt_show {
					left: -59%;
				}
			}
		}
	}
}
}
#nav{
.newStyle {
	.nav_two .nav_two_span .nav_three_box {
		height: 620px;
	}
	.nav_two .nav_two_span .nav_three_box .nav_three_row {
		display: block;
	}
	.nav_two .nav_two_span .nav_three_box .nt_row_left {
		display: block;
	}
	.nav_two .nav_two_span .nav_three_box .nt_row_right {
		display: block;
	}
	.nt_row_right_li .nt_show {
		display: block;
		opacity: 1;
		position: unset;
		width: auto;
		box-shadow: unset;
		box-shadow: 0 0 6px #3333331c;
		margin-bottom: 5px;
	}
	
	.nt_row_right .nt_row_right_li {
		margin: 10px 10px 10px 0;
		width: 120px;
		text-align: center;
		vertical-align: top;
	}
	.nt_row_right_li .title_text {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		width: 100%;
		margin-top: 2px;
	}
	.nt_show .nt_show_san2,.nt_show .nt_show_san {
		display: none;
	}
	.nav_two .nav_two_span .nav_three_box .nt_row_right .nt_row_right_li .nt_show img {
		width: 110px;
		height: 80px;
		margin: 0 auto;
		display: block;
	}
}

.newH{
	.nav_two .nav_two_span .nav_three_box {
		height: 423px;
	}
}
.newHE{
	.nav_two .nav_two_span .nav_three_box {
		height: 620px;
	}
}
}
.focusImg {
position: relative;
width: 135px;
display: inline-block;
.img {
	height: 45px;
	position: absolute;
	top: -35px;
	left: 0;
}
}

:deep .complaint .el-dialog {
margin-top: 10% !important;
.el-dialog__body {
	padding: 10px 20px;
}
}
:deep .complaint .el-dialog__header {
background-color: var(--bgColor);
text-align: center;
padding: 6px 20px;
.el-dialog__title {
	color: #fff;
	font-size: 15px;
}
.el-dialog__headerbtn {
	top: 3px !important;
	right: 6px;
}
.el-dialog__headerbtn .el-dialog__close {
	color: #fff;
}
}
:deep .complaint .el-button {
padding: 10px 20px;
width: calc(50% - 10px);
margin-right: 5px;
}
:deep .complaint .el-upload--picture-card {
width: 80px;
height: 80px;
line-height: 85px;
}
:deep .complaint .el-upload-list--picture-card .el-upload-list__item {
width: 80px;
height: 80px;
}
:deep .complaint .cancel {
background-color: #e3e3e3
}
:deep .complaint .sure {
color:#fff;
background-color: var(--bgColor,red)
}
.content_complaint {
position: relative;
.btn_my {
	position: absolute;
	top: 0;
	right: 10px;
	cursor: pointer;
	color: var(--bgColor,red);
}
.form_box {
	padding: 20px 0 0;
	box-sizing: border-box;
	.form_item {
		display: flex;
		align-items: center;
		margin: 10px 0;
		.lable {
			width: 100px;
			text-align: right;
		}
		.inp {
			padding-left: 5px;
			width: 100%;
		}
		em {
			padding-right: 5px;
			color: #FF0000;
			font-style: normal;
		}
		.input {
			width: 100%;
			height: 30px;
			padding: 5px;
			
			border: 1px solid #CACACA;
			border-radius: 4px 4px 4px 4px;
			box-sizing: border-box;
		}
		.textarea {
			width: 100%;
			padding: 5px;
			box-sizing: border-box;
			border: 1px solid #CACACA;
			border-radius: 4px 4px 4px 4px;
			font-family: 'Microsoft YaHei';
			outline: none;
		}
	}
	.btn_up {
		width: 170px;
		margin: 0 auto;
		background-color: #dcdcdc;
		color: #000;
		font-size: 14px;
		text-align: center;
		border-radius: 5px;
		padding: 8px;
		margin-top: 30px;
		cursor: pointer;
		span {
			margin-left: 5px;
		}
	}
}
}
</style>

